export enum Color {
  Runway = 'Runway',
  Vamp = 'Vamp',
  JetBlack = 'Jet Black',
  Sand = 'Sand',
  Mocha = 'Mocha',
  Pacific = 'Pacific',
  Navy = 'Navy',
  Spicy = 'Spicy',
  Astral = 'Astral',
  Fig = 'Fig',
  RoseTan = 'Rose Tan',
  HaloGrey = 'Halo Grey',
  Moondust = 'Moondust',
  StonewashBlue = 'Stonewash Blue',
  LilyAndSand = 'Lily And Sand',
  VampAndFig = 'Vamp And Fig',
  Lilac = 'Lilac',
  Cinnamon = 'Cinnamon',
  Peony = 'Peony',
  DeepAqua = 'Deep Aqua',
  SeaGlass = 'Sea Glass',
  ExplorerBlue = 'Explorer Blue',
  Charcoal = 'Charcoal',
  StormyBlue = 'Stormy Blue',
}

export const isColor = (maybeColor: unknown): maybeColor is Color => Object.values(Color).includes(maybeColor as Color);
